import { API_METHODS } from "../../constant";
export const personCodeValueApi = (
  _getAll,
  _get,
  _update,
  _create,
  _delete,
  paramsIn
) => {
  return {
    [API_METHODS.GET_PERSONE_CODE_VALUE]: () => {
      let urlReq = `/Person/${paramsIn.PersonId}/CodeValue/${paramsIn.id}`;
      return _get(urlReq);
    },
    [API_METHODS.GET_ALL_PERSONE_CODE_VALUE]: () => {
      let urlReq = `/Person/${paramsIn.PersonId}/CodeValue`;
      return _getAll(urlReq);
    },
    [API_METHODS.UPDATE_PERSONE_CODE_VALUE]: () => {
      let urlReq = `/Person/${paramsIn.PersonId}/CodeValue`;
      return _update(urlReq);
    },
    [API_METHODS.CREATE_PERSONE_CODE_VALUE]: () => {
      let urlReq = `/Person/${paramsIn.PersonId}/CodeValue`;
      return _create(urlReq);
    },
    [API_METHODS.DELETE_PERSONE_CODE_VALUE]: () => {
      let urlReq = `/Person/${paramsIn.PersonId}/CodeValue/${paramsIn.id}`;
      return _delete(urlReq);
    }
  };
};
